import { FC } from 'react';

import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from '../../base/Card/Card';
import { ScrollArea, ScrollBar } from '../../base/ScrollArea/ScrollArea';

interface TwCardProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  headerClassName?: string;
  cardContentClassName?: string;
  cardContentWrapperClassName?: string;
}

export const TwCard: FC<TwCardProps> = ({
  title,
  description,
  children,
  footer,
  className,
  headerClassName,
  cardContentClassName,
  cardContentWrapperClassName,
}) => {
  const onlyTitle = title && !description;

  return (
    <Card
      className={`flex flex-col h-full overflow-hidden relative ${
        className || ''
      }`}
    >
      <CardHeader
        className={
          onlyTitle
            ? `flex justify-center items-center p-[15px] border-b border-muted ${
                headerClassName || ''
              }`.trim()
            : `pb-3 border-b border-muted ${headerClassName || ''}`.trim()
        }
      >
        <CardTitle
          className={
            onlyTitle
              ? 'text-[16px] font-semibold w-full'
              : 'text-[16px] font-semibold'
          }
        >
          {title}
        </CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <ScrollArea
        className={`flex-1 min-h-0 w-full ${cardContentWrapperClassName || ''}`}
      >
        <CardContent
          className={`p-[15px] flex flex-col h-full ${
            cardContentClassName || ''
          }`}
          style={{
            height: '100%',
          }}
        >
          {children}
        </CardContent>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
      {footer && <CardFooter>{footer}</CardFooter>}
    </Card>
  );
};

TwCard.displayName = 'TwCard';
